/* SUPERFAN – interactividad de la home v2 (borrador, sin publicar).
   Sin dependencias. Todo es progresivo: si el JS no carga, la página se ve y
   funciona igual (los links siguen andando, el primer slide se ve, etc.). */
(function () {
  if (window.__sfStore) return;
  window.__sfStore = true;
  document.documentElement.classList.add("sf-js");
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function $all(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? "0" : "") + n; }

  /* Aparición al hacer scroll */
  function reveal() {
    var els = $all(".sf-reveal:not(.is-in)");
    if (!("IntersectionObserver" in window) || reduce) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Carruseles con flechas */
  function rails() {
    $all("[data-sf-railwrap]").forEach(function (wrap) {
      if (wrap.__sf) return; wrap.__sf = true;
      var prev = wrap.querySelector("[data-sf-prev]"), next = wrap.querySelector("[data-sf-next]");
      function rail() { return wrap.querySelector(".sf-tabpanel.is-active .sf-rail") || wrap.querySelector(".sf-rail"); }
      function update() {
        var r = rail(); if (!r || !prev || !next) return;
        prev.disabled = r.scrollLeft < 4;
        next.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 4;
      }
      function go(dir) { var r = rail(); if (r) r.scrollBy({ left: dir * r.clientWidth * 0.9, behavior: reduce ? "auto" : "smooth" }); }
      if (prev) prev.addEventListener("click", function () { go(-1); });
      if (next) next.addEventListener("click", function () { go(1); });
      $all(".sf-rail", wrap).forEach(function (r) { r.addEventListener("scroll", update, { passive: true }); });
      wrap.addEventListener("sf:tab", update);
      update();
    });
  }

  /* Slideshow del hero */
  function sliders() {
    $all("[data-sf-slider]").forEach(function (box) {
      if (box.__sf) return; box.__sf = true;
      var slides = $all(".sf-slide", box), dots = $all(".sf-dot", box);
      if (slides.length < 2) return;
      var dur = parseInt(box.getAttribute("data-dur") || "6", 10) * 1000;
      box.style.setProperty("--sf-dur", dur / 1000 + "s");
      var i = 0, t = null, paused = false;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle("is-active", k === i); s.setAttribute("aria-hidden", k === i ? "false" : "true"); });
        dots.forEach(function (d, k) { d.classList.remove("is-active"); void d.offsetWidth; d.classList.toggle("is-active", k === i); d.setAttribute("aria-current", k === i ? "true" : "false"); });
        schedule();
      }
      function schedule() { clearTimeout(t); if (!reduce && !paused) t = setTimeout(function () { show(i + 1); }, dur); }
      dots.forEach(function (d, k) { d.addEventListener("click", function () { show(k); }); });
      var p = box.querySelector("[data-sf-prev]"), nx = box.querySelector("[data-sf-next]");
      if (p) p.addEventListener("click", function () { show(i - 1); });
      if (nx) nx.addEventListener("click", function () { show(i + 1); });
      var x0 = null;
      box.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1)); x0 = null; });
      show(0);
    });
  }

  /* Cuenta regresiva (antes del inicio: "empieza en"; durante: "termina en") */
  function countdowns() {
    var els = $all("[data-sf-countdown]");
    if (!els.length) return;
    function tick() {
      var now = Date.now();
      els.forEach(function (el) {
        var start = Date.parse(el.getAttribute("data-start") || ""), end = Date.parse(el.getAttribute("data-end") || "");
        if (isNaN(end)) return;
        var live = isNaN(start) || now >= start;
        var target = live ? end : start;
        var ms = target - now;
        if (live && ms <= 0) { if (el.hasAttribute("data-hide-after")) el.style.display = "none"; return; }
        var s = Math.max(0, Math.floor(ms / 1000));
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
        var set = function (k, v) { $all("[data-" + k + "]", el).forEach(function (n) { n.textContent = v; }); };
        set("d", d); set("h", pad(h)); set("m", pad(m)); set("s", pad(sec));
        $all("[data-sf-state]", el).forEach(function (n) { n.textContent = live ? n.getAttribute("data-live") : n.getAttribute("data-soon"); });
        el.classList.toggle("is-live", live);
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* Pestañas */
  function tabs() {
    $all("[data-sf-tabs]").forEach(function (box) {
      if (box.__sf) return; box.__sf = true;
      var btns = $all("[data-tab]", box), panels = $all("[data-panel]", box);
      btns.forEach(function (b) {
        b.addEventListener("click", function () {
          var id = b.getAttribute("data-tab");
          btns.forEach(function (x) { x.classList.toggle("is-active", x === b); x.setAttribute("aria-selected", x === b ? "true" : "false"); });
          panels.forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-panel") === id); });
          box.dispatchEvent(new CustomEvent("sf:tab"));
        });
      });
    });
  }

  /* Copiar código de descuento */
  function copies() {
    document.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-sf-copy]");
      if (!b) return;
      var txt = b.getAttribute("data-sf-copy");
      var done = function () { var o = b.textContent; b.textContent = "Copied ✓"; setTimeout(function () { b.textContent = o; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, done); else done();
    });
  }

  /* Agregar al carrito sin salir de la página (solo productos de una variante) */
  function quickAdd() {
    document.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-sf-quick]");
      if (!b) return;
      e.preventDefault();
      if (b.disabled) return;
      var label = b.textContent;
      b.disabled = true; b.textContent = "Adding…";
      fetch(root + "cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute("data-sf-quick"), 10), quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error("add"); return fetch(root + "?sections=cart-icon-bubble"); })
        .then(function (r) { return r.json(); })
        .then(function (s) {
          var bubble = document.getElementById("cart-icon-bubble");
          if (bubble && s["cart-icon-bubble"]) {
            var tmp = document.createElement("div"); tmp.innerHTML = s["cart-icon-bubble"];
            var nuevo = tmp.querySelector(".shopify-section") || tmp;
            bubble.innerHTML = nuevo.innerHTML;
          }
          b.classList.add("is-done"); b.textContent = "Added to cart ✓";
          setTimeout(function () { b.classList.remove("is-done"); b.textContent = label; b.disabled = false; }, 2200);
        })
        .catch(function () { window.location.href = b.getAttribute("data-url") || root + "cart"; });
    });
  }

  /* Collector's Vault: miniaturas + zoom siguiendo el mouse */
  function vault() {
    $all("[data-sf-vault]").forEach(function (box) {
      if (box.__sf) return; box.__sf = true;
      var stage = box.querySelector(".sf-vault__stage"), main = stage && stage.querySelector("img");
      if (!stage || !main) return;
      stage.addEventListener("mousemove", function (e) {
        var r = stage.getBoundingClientRect();
        main.style.setProperty("--sf-zx", ((e.clientX - r.left) / r.width * 100) + "%");
        main.style.setProperty("--sf-zy", ((e.clientY - r.top) / r.height * 100) + "%");
      });
      $all(".sf-vault__thumb", box).forEach(function (t) {
        t.addEventListener("click", function () {
          main.src = t.getAttribute("data-src"); main.srcset = "";
          $all(".sf-vault__thumb", box).forEach(function (x) { x.classList.toggle("is-active", x === t); });
        });
      });
    });
  }

  function init() { reveal(); rails(); sliders(); tabs(); vault(); }
  copies(); quickAdd();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); countdowns(); });
  else { init(); countdowns(); }
  document.addEventListener("shopify:section:load", init);
})();
